<template>
  <div>
    <div class="flex justify-right" :class="inQuestionModal ? 'pt-3' : 'pt-4 pb-4 pl-4 pr-2'">
      <input
        id="infoRowTextfield"
        v-model="localTextFieldValue"
        type="text"
        autocomplete="on"
        :name="fieldName"
        :aria-label="placeholder"
        class="form-input rounded-lg bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5 flex-grow"
        :class="inQuestionModal ? '' : 'mr-2'"
        :placeholder="placeholder"
        @keyup.enter="savedOption"
        @blur="touched = true"
      />
      <button
        v-if="!brandedActionType"
        class="px-4 py-2 text-gray-brand-600 border border-transparent font-semibold text-sm rounded-full hover:border-gray-brand-600 flex-grow-0"
        @click="savedOption"
      >
        {{ actionText }}
      </button>
    </div>
    <p v-if="showEmailError" class="text-sm text-red-500" :class="inQuestionModal ? 'mt-1' : 'px-4 -mt-2 mb-1'">
      {{ emailErrorMessage }}
    </p>
    <QuestionFooterButtons
      v-if="brandedActionType && !inlineMode"
      :action-text="actionText"
      :can-proceed="canProceed"
      :show-skip="showOptionalButton"
      @next="savedOption"
      @skip="skipQuestion"
    />
    <div v-if="brandedActionType && inlineMode" class="p-4 pt-0 mt-1">
      <PrimaryButton
        @click="savedOption"
        class="w-full"
        :class="{
          'cursor-pointer opacity-100': canProceed,
          'cursor-not-allowed opacity-50': !canProceed
        }"
        :size="'xl'"
        :streaking="canProceed"
        :justify="'justify-center'"
      >
        {{ actionText }}
      </PrimaryButton>
    </div>
    <div v-if="showCancelButton" class="p-4 pt-0 -mt-1">
      <SecondaryButton v-if="brandedActionType" @click="cancelAnswer" class="w-full" :size="'xl'">
        Cancel
      </SecondaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from '@/components/Molecules/PrimaryButton'
import SecondaryButton from '@/components/Molecules/SecondaryButton'
import QuestionFooterButtons from '@/components/Checkout/QuestionFooterButtons'
import isValidEmail from '@/utils/isValidEmail'
export default {
  name: 'InfoRowEditField',
  components: { PrimaryButton, SecondaryButton, QuestionFooterButtons },
  props: ['textFieldValue', 'placeholder', 'actionText', 'actionType', 'name', 'optional', 'mode'],
  inject: {
    inQuestionModal: { default: false }
  },
  data() {
    return {
      localTextFieldValue: this.textFieldValue,
      touched: false
    }
  },
  computed: {
    brandedActionType() {
      return this.actionType == 'branded'
    },
    fieldName() {
      if (this.name && this.name.length > 0) return this.name
      return 'infoRowTextfield'
    },
    isEmailQuestion() {
      return this.fieldName == 'email'
    },
    answerIsValidEmail() {
      return isValidEmail(this.localTextFieldValue)
    },
    canProceed() {
      if (this.isEmailQuestion) {
        return !!(this.localTextFieldValue && this.localTextFieldValue?.length > 0 && this.answerIsValidEmail)
      } else {
        return !!(this.localTextFieldValue && this.localTextFieldValue?.length > 0)
      }
    },
    showEmailError() {
      return this.isEmailQuestion && this.touched && !this.answerIsValidEmail
    },
    emailErrorMessage() {
      return 'Please enter a valid email address.'
    },
    showOptionalButton() {
      return this.optional && !this.inlineMode
    },
    showCancelButton() {
      return this.inlineMode
    },
    inlineMode() {
      return this.mode == 'inline'
    }
  },
  mounted() {},
  methods: {
    savedOption() {
      if (this.isEmailQuestion && !this.canProceed) {
        this.touched = true
        return
      }
      this.$emit('savedOption', this.localTextFieldValue)
    },
    skipQuestion() {
      this.$emit('skipQuestion')
    },
    cancelAnswer() {
      this.$emit('cancelAnswer')
    }
  }
}
</script>
